export default "__VITE_PUBLIC_ASSET__98ae0202__"